const ShoppingCartIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={className}
    >
      <path
        d="M15.9388 6.51078V6.18645C15.9388 5.07078 15.5095 3.99402 14.7392 3.20267C13.969 2.41132 12.9209 1.97024 11.835 1.97024C10.7491 1.97024 9.70104 2.41132 8.93078 3.20267C8.16053 3.99402 7.73121 5.07078 7.73121 6.18645V6.51078H15.9388ZM5.83715 12.6729V8.45672H5.31944C4.49868 8.45672 3.81682 9.10537 3.74105 9.94862L2.90767 20.327C2.8319 21.261 3.55165 22.0783 4.47343 22.0783H19.1966C20.1184 22.0783 20.8381 21.261 20.7624 20.327L19.929 9.94862C19.8532 9.10537 19.1713 8.45672 18.3506 8.45672H17.8329V12.6729C17.8329 13.2048 17.4036 13.6459 16.8858 13.6459C16.3681 13.6459 15.9388 13.2048 15.9388 12.6729V8.45672H7.73121V12.6729C7.73121 13.2048 7.30189 13.6459 6.78418 13.6459C6.26647 13.6459 5.83715 13.2048 5.83715 12.6729ZM5.83715 6.18645C5.83715 4.55186 6.4685 2.98213 7.59231 1.82754C8.71612 0.672941 10.244 0.024292 11.835 0.024292C13.426 0.024292 14.9539 0.672941 16.0777 1.82754C17.2015 2.98213 17.8329 4.55186 17.8329 6.18645V6.51078H18.3506C20.1563 6.51078 21.6589 7.93781 21.8104 9.77997L22.6564 20.1583C22.8206 22.234 21.2296 24.0243 19.1966 24.0243H4.47343C2.44047 24.0243 0.849453 22.234 1.01361 20.1583L1.85962 9.77997C2.01114 7.93781 3.51377 6.51078 5.31944 6.51078H5.83715V6.18645Z"
        fill="#191516"
      />
    </svg>
  );
};

export default ShoppingCartIcon;
